var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar-subnav"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeNavItems.length,
      expression: "activeNavItems.length"
    }],
    staticClass: "sidebar-subnav__wrapper"
  }, [_c('transition-group', {
    staticClass: "sidebar-subnav__nav-items",
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, _vm._l(_vm.activeNavItems, function (navItem, index) {
    return _c('div', {
      key: navItem._id,
      staticClass: "sidebar-subnav__nav-item-wrapper",
      attrs: {
        "data-index": index
      }
    }, [_c('router-link', {
      staticClass: "btn",
      class: [{
        'filtered': navItem.filter
      }, {
        'can-interact': _vm.canInteract(navItem)
      }],
      attrs: {
        "tag": "button",
        "to": _vm.getItemUrl(navItem),
        "dir": _vm.lang.rtl ? 'rtl' : 'ltr'
      },
      nativeOn: {
        "click": function click($event) {
          _vm.playClickSound();
          _vm.bus.$emit('navClick');
          _vm.bus.$emit('startAnimations');
        }
      }
    }, [navItem.icon && navItem.icon[1] ? _c('div', {
      staticClass: "btn__icon"
    }, [_c('fa', {
      attrs: {
        "icon": navItem.icon
      }
    })], 1) : _vm._e(), _c('div', {
      domProps: {
        "innerHTML": _vm._s(navItem.label[_vm.lang.code] || navItem.label['en'])
      }
    })])], 1);
  }), 0)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }